import { twMerge } from 'tailwind-merge';

import { ButtonVariant } from 'types';

const primaryClassName =
  'text-neutral-100 bg-primary-300 border-primary-300 hover:bg-primary-400 active:bg-primary-500';
const outlinePrimaryClassName =
  'font-light text-primary-300 bg-neutral-100 border-primary-300 hover:bg-neutral-200 hover:text-primary-400 hover:border-primary-400 active:bg-neutral-300 active:text-primary-500 active:border-primary-500';
const secondaryClassName =
  'text-neutral-100 bg-neutral-500 border-neutral-500 hover:bg-neutral-600 active:bg-neutral-700';
const outlineSecondaryClassName =
  'font-light text-neutral-500 bg-neutral-100 border-neutral-500 hover:bg-neutral-200 hover:text-neutral-600 hover:border-neutral-600 active:bg-neutral-300 active:text-neutral-700 active:border-neutral-700';
const successClassName =
  'text-neutral-100 bg-success-300 border-success-300 hover:bg-success-400 active:bg-success-500';
const outlineSuccessClassName =
  'font-light text-success-300 bg-neutral-100 border-success-300 hover:bg-neutral-200 hover:text-success-400 hover:border-success-400 active:bg-neutral-300 active:text-success-500 active:border-success-500';
const dangerClassName =
  'text-neutral-100 bg-danger-300 border-danger-300 hover:bg-danger-400 active:bg-danger-500';
const outlineDangerClassName =
  'font-light text-danger-300 bg-neutral-100 border-danger-300 hover:bg-neutral-200 hover:text-danger-400 hover:border-danger-400 active:bg-neutral-300 active:text-danger-500 active:border-danger-500';
const linkClassName =
  'text-neutral-600 shadow-none outline-none bg-transparent underline transform-none py-2 px-0 min-w-0 border-none lg:hover:opacity-50';
const transparentClassName =
  'text-primary-300 font-bold shadow-none bg-transparent transform-none min-w-0 border-none lg:hover:text-primary-500 lg:hover:bg-primary-200';

const VARIANTS = {
  primary: primaryClassName,
  'outline-primary': outlinePrimaryClassName,
  secondary: secondaryClassName,
  'outline-secondary': outlineSecondaryClassName,
  success: successClassName,
  'outline-success': outlineSuccessClassName,
  danger: dangerClassName,
  'outline-danger': outlineDangerClassName,
  link: linkClassName,
  transparent: transparentClassName,
};

interface GetButtonStyleProps {
  variant: ButtonVariant;
  full: boolean;
  className: string;
  hidden: boolean;
}

export function getButtonStyle({
  variant,
  full,
  className,
  hidden,
}: GetButtonStyleProps) {
  return twMerge(
    'flex h-fit min-h-10 w-fit min-w-36 cursor-pointer select-none items-center justify-center gap-1 rounded-lg border border-solid px-3 py-1 text-xs font-normal no-underline transition-colors duration-150 ease-in-out disabled:cursor-not-allowed disabled:opacity-40 md:text-sm disabled:lg:hover:opacity-40',
    VARIANTS[variant],
    full && 'w-full',
    className,
    hidden && 'hidden'
  );
}
